<template>
  <div class="menu-item-container" @click="onClick">
    <img alt="" :src="item.photo" />
    <span>{{ item.title }}</span>
  </div>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    onClick: function() {
      this.$emit("select-item", this.item.key);
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-item {
  &-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 90px;
    padding: 20px 0;
    cursor: pointer;

    img {
      width: auto;
      height: auto;
      object-fit: contain;
    }

    span {
      color: #333333;
      font-size: 0.875rem;
    }
  }
}
</style>
